import { Component, OnInit } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";

@Component({
  selector: "app-listings",
  templateUrl: "./listings.component.html",
  styleUrls: ["./listings.component.scss"]
})
export class ListingsFeatureComponent
  implements OnInit, Resolve<Observable<any>> {
  constructor() {}

  resolve() {
    return new Observable();
  }

  ngOnInit(): void {}
}
